export default {
  init() {
    // JavaScript to be fired on all pages
    var toggleButton = document.querySelector('#toggle-menu');
    var menu = document.querySelector('#menu');
    var body = document.querySelector('body');
    var overlay = document.querySelector('#overlay');

    toggleButton.onclick = function() {
      toggleButton.classList.toggle('active');
      menu.classList.toggle('active');
      body.classList.toggle('overlay');
    }

    overlay.onclick = function() {
      body.classList.remove('overlay');
      menu.classList.remove('active');
      toggleButton.classList.remove('active');
    }

    // JavaScript to be fired on all pages
    var navigationWrapper = document.querySelector('#navigation');
    var navigationButtonOpen = document.querySelector('.notebook__title', navigationWrapper);
    var navigation = document.querySelector('.notebook__content', navigationWrapper);

    if(navigationButtonOpen != undefined) {
      navigationButtonOpen.onclick = function () {
          navigationButtonOpen.classList.toggle('active');
          navigation.classList.toggle('active');
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js